"use client";

import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Stack, type StackProps } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useCarousel } from "./CarouselWrapper";

type CarouselPaginationProps = StackProps;

export const CarouselPagination: FC<CarouselPaginationProps> = ({
  className,
  ...rest
}) => {
  const { api } = useCarousel();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [slides, setSlides] = useState<number[]>([]);
  useEffect(() => {
    if (!api) return;

    const updateSlides = () => {
      setSlides(Array.from({ length: api.slideNodes().length }));
      setSelectedIndex(api.selectedScrollSnap());
    };

    api.on("select", updateSlides);
    updateSlides();

    return () => {
      if (!api) return;
      api.off("select", updateSlides);
    };
  }, [api]);

  const scrollTo = (index: number) => {
    api?.scrollTo(index);
  };

  return (
    <Stack
      className={cn("mt-4 min-h-[10px] gap-3 flex-center-row", className)}
      {...rest}
    >
      {slides.map((_, index) => (
        <div
          key={index}
          className={cn(
            `h-[10px] w-[10px] rounded-full`,
            selectedIndex === index
              ? "box-border border border-[#009DDE] bg-white"
              : "bg-light-gray",
          )}
          onClick={() => scrollTo(index)}
        />
      ))}
    </Stack>
  );
};
